import { render, staticRenderFns } from "./waiting.vue?vue&type=template&id=4cecbd6d&scoped=true&"
import script from "./waiting.vue?vue&type=script&lang=js&"
export * from "./waiting.vue?vue&type=script&lang=js&"
import style0 from "./waiting.vue?vue&type=style&index=0&id=4cecbd6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cecbd6d",
  null
  
)

export default component.exports